// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3nRgC","title":"Header_title__1b8Ko","left":"Header_left__JiJ43","clinicName":"Header_clinicName__bzXmn"};